import { create } from "zustand";
import { devtools } from "zustand/middleware";

type Industry = {
  id: number;
  name: string;
  slug: string;
  is_primary: boolean;
};

type Subscription = {
  id: number;
  status: "trial" | "active" | "past_due" | "cancelled" | "paused";
  plan_id: number;
  plan_name: string;
  plan_slug: string;
  started_at: string | null;
  ends_at: string | null;
};

interface CompanyStore {
  company: {
    id: number;
    name: string;
    slug: string;
    logo_url: string | null;

    email: string;
    phone: string | null;
    website: string | null;

    primary_colour: string | null;
    secondary_colour: string | null;

    industries: Industry[];

    subscription: Subscription | null;
  } | null;

  setCompany: (data: any) => void;

  updateCompany: (data: Partial<CompanyStore["company"]>) => void;

  updateSubscription: (data: Partial<Subscription>) => void;


  clearCompany: () => void;
}

export const useCompanyStore = create<CompanyStore>()(
  devtools((set, get) => {
    const setCompanyState = (data: any) => {
      set({
        company: {
          id: data.id,
          name: data.name,
          slug: data.slug,
          logo_url: data.logo_url ?? null,

          email: data.email,
          phone: data.phone ?? null,
          website: data.website ?? null,

          primary_colour: data.primary_colour ?? null,
          secondary_colour: data.secondary_colour ?? null,

          industries: data.industries ?? [],

          subscription: data.subscription
            ? {
                id: data.subscription.id,
                status: data.subscription.status,
                plan_id: data.subscription.plan_id,
                plan_name: data.subscription.plan_name,
                plan_slug: data.subscription.plan_slug,
                started_at: data.subscription.started_at,
                ends_at: data.subscription.ends_at,
              }
            : null,
        }
      });
    };

    const resetCompany = () => {
      set({
        company: null,
      });
    };

    return {
      company: null,

      setCompany: setCompanyState,
      updateCompany: (data) => {
        set((state) => {
          if (!state.company) return state;

          return {
            company: {
              ...state.company,
              ...data,
            },
          };
        });
      },

      updateSubscription: (data) => {
        set((state) => {
          if (!state.company || !state.company.subscription) return state;

          return {
            company: {
              ...state.company,
              subscription: {
                ...state.company.subscription,
                ...data,
              },
            },
          };
        });
      },

      clearCompany: resetCompany,
    };
  })
);